import Button from './Button';

export type ButtonVariants = 'blue' | 'red' | 'yellow' | 'green' | 'white';
export type ButtonSizes = 'min' | 'std' | 'lg';

export default Button;
